module.exports = __webpack_public_path__ + "img/watage_res_11.ca6462cd.gif";